import React from "react";
import styles from "./styles.m.css";
import { get } from "lodash";
import LastestNews from "./latest-news/latestnews";
import TrendingNews from "./trending-news/trendingnews";
import SitemapMenu from "./sitemap-menu/sitemapmenu";
import NavMenubar from "../../../rows/header/nav-menubar";

const Sitemap = Menu => {
  const menuitem = get(Menu, ["data", "header", "menuGroup"], null);
  if (!menuitem && !menuitem.length) {
    return null;
  }
  return (
    <div className={`main-page ${styles["main"]}`}>
      <div className={`container ${styles["sitemap-wrapper"]}`}>
        <h1>Sitemap</h1>
        <div className={`${styles["sitemap-grid"]}`}>
          <LastestNews />
          <TrendingNews />
        </div>

        <React.Fragment>
          <SitemapMenu menuGroup={menuitem} />
        </React.Fragment>
      </div>
    </div>
  );
};

Sitemap.prototype = {
  Menu: NavMenubar.propTypes.menuGroup
};

export { Sitemap };
